<template>
    <v-card class="mx-auto" elevation="16" max-width="100hv">
        <v-card-item>
            <v-card-title>Contacto / Contact</v-card-title>
            <v-card-subtitle>
                <div v-if="language == 'EN'">
                    <h3>You are in the section to update only in English</h3>
                    <h3>English</h3>
                </div>
            </v-card-subtitle>
        </v-card-item>
        <v-card-text>
            <v-row class="gap-y-6">
                <div class="background">
                    <div class="contact-page">
                        <div class="contact-emails">
                            <div class="email-item">
                                <h3 @dblclick="openEditModal('COBRE_CONTACT_01_' + 'EN')"><span v-html="filterData('COBRE_CONTACT_01_' + 'EN')"></span></h3>
                                <p @dblclick="openEditModal('COBRE_CONTACT_02_' + 'EN')"><span v-html="filterData('COBRE_CONTACT_02_' + 'EN')"></span></p>
                                <h3 @dblclick="openEditModal('COBRE_CONTACT_03_' + 'EN')"><span v-html="filterData('COBRE_CONTACT_03_' + 'EN')"></span></h3>
                                <p @dblclick="openEditModal('COBRE_CONTACT_04_' + 'EN')"><span v-html="filterData('COBRE_CONTACT_04_' + 'EN')"></span></p>
                                <h3 @dblclick="openEditModal('COBRE_CONTACT_05_' + 'EN')"><span v-html="filterData('COBRE_CONTACT_05_' + 'EN')"></span></h3>
                                <p @dblclick="openEditModal('COBRE_CONTACT_06_' + 'EN')"><span v-html="filterData('COBRE_CONTACT_06_' + 'EN')"></span></p>
                            </div>

                        </div>
                    </div>
                </div>
            </v-row>
        </v-card-text>
    </v-card>
    <UpdateModal :visible="dialogVisible" :current-text="currentText" current-page="CONTACT-COBRE" :text-id="currentTextId"
        @update:visible="updateDialogVisible" @save-text="updateText" />
    <ModalUpdateImage :is-visible-image-u="dialogVisibleImage" :image-id="currentImageId" image-section="CONTACT-COBRE"
        @update:visible="updateDialogVisibleImage" @update:files="getImages" />
</template>

<script>
import { defineComponent, onMounted, ref } from "vue";
import {
    BASEURL,
    getLanguageForUpdateContent,
    setLanguageForUpdateContent,
} from "@/kernel/utils";
import { showInfoToast } from "@/kernel/alerts";
import UpdateModal from "../../components/UpdateModal.vue";
import { getSectionByPageandlanguage, getImageBySection } from "../../services/sections-service";
import ModalUpdateImage from "../../components/ModalUpdateImage.vue";

export default defineComponent({
    name: "UpdateAboutEn",
    components: {
        UpdateModal,
        ModalUpdateImage,
    },
    setup() {
     

        const selectedImage = ref(null);
        const modalVisible = ref(false);
   
        const dataContact = ref([
            {
                section_id: "COBRE_CONTACT_01_EN",
                description: "Suppliers Office",
            },
            {
                section_id: "COBRE_CONTACT_01_ES",
                description: "Suppliers Office",
            },
            {
              section_id: "COBRE_CONTACT_02_EN",
              description: "suppliers@cobredelmayo.com",
            },
            {
              section_id: "COBRE_CONTACT_02_ES",
              description: "suppliers@cobredelmayo.com",
            },
            {
              section_id: "COBRE_CONTACT_03_EN",
              description: "Human Resources Office",
            },
            {
              section_id: "COBRE_CONTACT_03_ES",
              description: "Human Resources Office",
            },
            {
              section_id: "COBRE_CONTACT_04_EN",
              description: "hr@cobredelmayo.com",
            },
            {
              section_id: "COBRE_CONTACT_04_ES",
              description: "hr@cobredelmayo.com",
            },
            {
              section_id: "COBRE_CONTACT_05_EN",
              description: "Investor Relations Office",
            },
            {
              section_id: "COBRE_CONTACT_05_ES",
              description: "Investor Relations Office",
            },
            {
              section_id: "COBRE_CONTACT_06_EN",
              description: "ir@cobredelmayo.com",
            },
            {
              section_id: "COBRE_CONTACT_06_ES",
              description: "ir@cobredelmayo.com",
            },
        ]);

        const fetchData = async () => {
            try {
                const dataForm = {
                    page: "CONTACT-COBRE",
                    language: "EN",
                };
                const response = await getSectionByPageandlanguage(dataForm);
                if (response.status === 200) {
                    if (parseInt(response.data.length) !== 0) {
                        dataContact.value = response.data;
                    }
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        const filterData = (found_id) => {
            const filteredData = dataContact.value.filter(
                (item) => item.section_id === found_id
            );
            return filteredData.length > 0 ? filteredData[0].description : null;
        };


        const changeLanguage = () => {
            const lang = getLanguageForUpdateContent() === "EN" ? "ES" : "EN";
            setLanguageForUpdateContent(lang);
            showInfoToast(
                `Language changed to ${lang === "EN" ? "English" : "Spanish"}`
            );
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        };

        const dialogVisible = ref(false);
        const currentText = ref("");
        const currentTextId = ref("");

        const updateDialogVisible = (visible) => {
            dialogVisible.value = visible;
        };

        const updateText = ({ id, text }) => {
            const index = dataContact.value.findIndex((item) => item.section_id === id);
            if (index !== -1) {
                dataContact.value[index].description = text;
            }
        };

        const openEditModal = (textId) => {
            showInfoToast(`Double click to edit the text: ${textId}`);
            const textToEdit = filterData(textId);
            currentText.value = textToEdit;
            currentTextId.value = textId;
            dialogVisible.value = true;
        };

        const imagesHome = ref([]);

        const dialogVisibleImage = ref(false);
        const currentImageId = ref("");

        const updateDialogVisibleImage = (visible) => {
            dialogVisibleImage.value = visible;
        };

        const openEditImageModal = (imageId) => {
            showInfoToast(`Double click to edit the image: ${imageId}`);
            currentImageId.value = imageId;
            dialogVisibleImage.value = true;
        };

        const searchImage = (imageId) => {
            const foundImage = imagesHome.value.find(
                (image) => image.image_id === imageId
            );
            return foundImage ? BASEURL + foundImage.image_path : null;
        };

        const getImages = async () => {
            try {
                const dataForm = {
                    page: "CONTACT-COBRE",
                };
                const result = await getImageBySection(dataForm);
                if (result.status === 200) {
                    if (result.data.content !== null) {
                        imagesHome.value = result.data.content;
                    }
                }
            } catch (error) {
                console.log("Error fetching images:", error);
            }
        };

        onMounted(() => {
            fetchData();
            getImages();
        });

        return {
            BASEURL,
            language: getLanguageForUpdateContent(),
            changeLanguage,
            filterData,
            openEditModal,
            updateDialogVisible,
            updateText,
            dialogVisible,
            currentText,
            currentTextId,
            selectedImage,
            modalVisible,
            searchImage,
            updateDialogVisibleImage,
            openEditImageModal,
            dialogVisibleImage,
            currentImageId,
            getImages,
        };
    },
});
</script>

<style scoped>
.background {
  background-color: #fffdfd;
  width: 100%;
  height: 100vh;
}
.contact-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 2rem;
  margin-top: 50px;
}

.contactTitleStyles {
  background-size: cover;
  background-position: center;
  height: 400px; /* Ajusta el tamaño según lo que necesites */
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: 140%;
  background-position: center;
  background-repeat: no-repeat;
  margin-top: 64px;
  margin-bottom: 2rem;
  border-radius: 16px;
}

.contact-title {
  margin-top: 54px;
  text-align: center;
  font-size: 4.5rem;
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
  margin-bottom: 2rem;
  font-weight: bold;
}

.contact-emails {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 30rem;
  
}

.email-item {
  flex: 1;
  min-width: 250px;
  background-color: #da302b;
  color: white;
  padding: 1.5rem;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.email-item h2 {
  font-size: 1.2rem;
  margin-bottom: 0.5rem;
}

.email-item p {
  font-size: 1rem;
  margin: 0;
}

.contact-form-container {
  background-color: #fff;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.form-description {
  text-align: center;
  font-size: 1.2rem;
  margin-bottom: 2rem;
  color: #555;
}

.contact-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.form-row {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.form-group {
  flex: 1;
  min-width: 200px;
}

.form-group.half-width {
  flex: 1;
  min-width: calc(50% - 0.5rem);
}

.form-group.third-width {
  flex: 1;
  min-width: calc(33.333% - 0.666rem);
}

.form-group.full-width {
  flex: 100%;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 600;
  color: #333;
}

.form-control {
  width: 100%;
  padding: 0.8rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  transition: border-color 0.3s;
}

.form-control:focus {
  border-color: #da302b;
  outline: none;
}

.submit-btn {
  background-color: #da302b;
  color: white;
  padding: 1rem 3rem;
  border: none;
  border-radius: 4px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background-color 0.3s;
  text-transform: uppercase;
  font-weight: bold;
}

.submit-btn:hover {
  background-color: #b82622;
}

.message-container {
  margin-top: 2rem;
  padding: 1rem;
  border-radius: 4px;
}

.message-text {
  text-align: center;
  font-size: 1.1rem;
  color: #da302b;
  font-weight: bold;
}

@media (max-width: 768px) {
  .email-item {
    min-width: 100%;
  }

  .form-group.half-width,
  .form-group.third-width {
    min-width: 100%;
  }

  .contactTitleStyles {
    height: 300px;
  }
}

.text-obligatory {
  color: #da302b;
}
/* Estilos de la tarjeta */
.language-tag {
    font-size: 0.75rem;
    background: rgba(255, 255, 255, 0.2);
    padding: 2px 6px;
    border-radius: 4px;
}

.action-btn {
    padding: 10px 20px;
    border: none;
    border-radius: 8px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
}

.secondary-btn {
    background: #f59e0b;
    color: white;
}

.secondary-btn:hover {
    background: #d97706;
    box-shadow: 0 4px 6px rgba(245, 158, 11, 0.3);
}
</style>